import { call, put, take } from "redux-saga/effects";
import { normalize } from "normalizr";
import ticketOrdersSchema from "../schemas/ticketOrders";
import events from "../schemas/events";
import { statusCodeIsBelow400, isResponseSuccessful } from "../helpers/utility";
import api from "../api/api";

import {
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_FAIL,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_ASYNC_START,
  FETCH_EVENTS_ASYNC_END,
  DELETE_EVENT_TICKET_REQUEST,
  DELETE_EVENT_TICKET_ASYNC_START,
  DELETE_EVENT_TICKET_SUCCESS,
  DELETE_EVENT_TICKET_FAIL,
  DELETE_EVENT_TICKET_ASYNC_END,
  DELETE_EVENT_EXTENSION_REQUEST,
  DELETE_EVENT_EXTENSION_SUCCESS,
  DELETE_EVENT_EXTENSION_FAIL,
  DELETE_EVENT_EXTENSION_ASYNC_END,
  DELETE_EVENT_EXTENSION_ASYNC_START
} from "../actions/actions";

import {
  ADD_EVENT_REQUEST,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  ADD_EVENT_ASYNC_START,
  ADD_EVENT_ASYNC_END
} from "../actions/actions";

import {
  CREATE_EVENT_TICKET_ORDER_REQUEST,
  CREATE_EVENT_TICKET_ORDER_SUCCESS,
  CREATE_EVENT_TICKET_ORDER_FAIL,
  CREATE_EVENT_TICKET_ORDER_ASYNC_END,
  CREATE_EVENT_TICKET_ORDER_ASYNC_START
} from "../actions/actions";

import {
  FETCH_USER_EVENTS_REQUEST,
  FETCH_USER_EVENTS_SUCCESS,
  FETCH_USER_EVENTS_FAIL,
  FETCH_USER_EVENTS_ASYNC_END,
  FETCH_USER_EVENTS_ASYNC_START
} from "../actions/actions";

import {
  FETCH_EVENT_CATEGORIES_REQUEST,
  FETCH_EVENT_CATEGORIES_SUCCESS,
  FETCH_EVENT_CATEGORIES_FAIL,
  FETCH_EVENT_CATEGORIES_ASYNC_END,
  FETCH_EVENT_CATEGORIES_ASYNC_START
} from "../actions/actions";

import {
  CHECK_EVENT_TOP_STUDENTS_REQUEST,
  CHECK_EVENT_TOP_STUDENTS_SUCCESS,
  CHECK_EVENT_TOP_STUDENTS_FAIL,
  CHECK_EVENT_TOP_STUDENTS_ASYNC_START,
  CHECK_EVENT_TOP_STUDENTS_ASYNC_END
} from "../actions/actions";

import {
  FETCH_SINGLE_EVENT_REQUEST,
  FETCH_SINGLE_EVENT_SUCCESS,
  FETCH_SINGLE_EVENT_FAIL,
  FETCH_SINGLE_EVENT_ASYNC_START,
  FETCH_SINGLE_EVENT_ASYNC_END
} from "../actions/actions";

import {
  EDIT_EVENT_REQUEST,
  EDIT_EVENT_SUCCESS,
  EDIT_EVENT_FAIL,
  EDIT_EVENT_ASYNC_START,
  EDIT_EVENT_ASYNC_END
} from "../actions/actions";

import {
  FETCH_ALL_EVENT_TEMPLATES_REQUEST,
  FETCH_ALL_EVENT_TEMPLATES_SUCCESS,
  FETCH_ALL_EVENT_TEMPLATES_FAIL,
  FETCH_ALL_EVENT_TEMPLATES_ASYNC_START,
  FETCH_ALL_EVENT_TEMPLATES_ASYNC_END
} from "../actions/actions";

import {
  FETCH_BOUGHT_EVENTS_REQUEST,
  FETCH_BOUGHT_EVENTS_SUCCESS,
  FETCH_BOUGHT_EVENTS_FAIL,
  FETCH_BOUGHT_EVENTS_ASYNC_START,
  FETCH_BOUGHT_EVENTS_ASYNC_END
} from "../actions/actions";

export function* fetchEvents() {
  while (true) {
    const { all, queryString } = yield take(FETCH_EVENTS_REQUEST);
    yield put({ type: FETCH_EVENTS_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors }
        }
      } = yield call(api.getEventsList, all, queryString);

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_EVENTS_SUCCESS,
          events: normalize(data.events, events),
          count: data.count
        });
      } else {
        yield put({
          type: FETCH_EVENTS_FAIL,
          error: general_errors
        });
      }

      yield put({ type: FETCH_EVENTS_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_EVENTS_FAIL, error });
      yield put({ type: FETCH_EVENTS_ASYNC_END });
    }
  }
}

export function* fetchEventCategories() {
  while (true) {
    yield take(FETCH_EVENT_CATEGORIES_REQUEST);
    yield put({ type: FETCH_EVENT_CATEGORIES_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors }
        }
      } = yield call(api.getEventCategories);

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_EVENT_CATEGORIES_SUCCESS,
          eventCategories: data.event_categories,
          count: data.count
        });
      } else {
        yield put({
          type: FETCH_EVENT_CATEGORIES_FAIL,
          error: general_errors
        });
      }

      yield put({ type: FETCH_EVENT_CATEGORIES_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_EVENT_CATEGORIES_FAIL, error });
      yield put({ type: FETCH_EVENT_CATEGORIES_ASYNC_END });
    }
  }
}
// this a legacy
export function* fetchUserEvents() {
  while (true) {
    yield take(FETCH_USER_EVENTS_REQUEST);
    yield put({ type: FETCH_USER_EVENTS_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors }
        }
      } = yield call(api.getUserTicketOrders);

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_USER_EVENTS_SUCCESS,
          ticket_orders: normalize(data.ticket_orders, ticketOrdersSchema)
        });
      } else {
        yield put({
          type: FETCH_USER_EVENTS_FAIL,
          error: general_errors
        });
      }

      yield put({ type: FETCH_USER_EVENTS_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_USER_EVENTS_FAIL, error });
      yield put({ type: FETCH_USER_EVENTS_ASYNC_END });
    }
  }
}

export function* fetchBoughtEvents() {
  while (true) {
    yield take(FETCH_BOUGHT_EVENTS_REQUEST);
    yield put({ type: FETCH_BOUGHT_EVENTS_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors }
        }
      } = yield call(api.fetchBoughtEvents);

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_BOUGHT_EVENTS_SUCCESS,
          events: normalize(data.events, events),
          count: data.count
        });
      } else {
        yield put({
          type: FETCH_BOUGHT_EVENTS_FAIL,
          error: general_errors
        });
      }
    } catch (error) {
      yield put({ type: FETCH_BOUGHT_EVENTS_FAIL, error });
    } finally {
      yield put({ type: FETCH_BOUGHT_EVENTS_ASYNC_END });
    }
  }
}

export function* addEvent() {
  while (true) {
    const { resolve, reject, formData } = yield take(ADD_EVENT_REQUEST);
    yield put({ type: ADD_EVENT_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.createEvent, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: ADD_EVENT_SUCCESS,
          event: data.event
        });
        resolve(data.event);
      } else {
        yield put({
          type: ADD_EVENT_FAIL,
          error: general_errors
        });
        reject({ general_errors, form_errors });
      }

      yield put({ type: ADD_EVENT_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: ADD_EVENT_FAIL, error });
      yield put({ type: ADD_EVENT_ASYNC_END });
    }
  }
}

export function* checkEventTopStudents() {
  while (true) {
    const { formData, resolve, reject } = yield take(
      CHECK_EVENT_TOP_STUDENTS_REQUEST
    );
    yield put({ type: CHECK_EVENT_TOP_STUDENTS_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.getTopStudentsForEvent, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: CHECK_EVENT_TOP_STUDENTS_SUCCESS,
          topStudentsData: data
        });

        resolve(data);
      } else {
        yield put({ type: CHECK_EVENT_TOP_STUDENTS_FAIL });
        reject({ form_errors, general_errors });
      }

      yield put({ type: CHECK_EVENT_TOP_STUDENTS_ASYNC_END });
    } catch (error) {
      const messages = ["انجام درخواست مقدور نبود. میتوانید مجددا تلاش"];
      reject({ general_errors: messages });
      yield put({ type: CHECK_EVENT_TOP_STUDENTS_FAIL, error });
      yield put({ type: CHECK_EVENT_TOP_STUDENTS_ASYNC_END });
      console.log(error);
    }
  }
}

export function* purchaseEvent() {
  while (true) {
    const { formData, resolve, reject } = yield take(
      CREATE_EVENT_TICKET_ORDER_REQUEST
    );
    yield put({ type: CREATE_EVENT_TICKET_ORDER_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.purchaseEvent, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: CREATE_EVENT_TICKET_ORDER_SUCCESS,
          ticket_order: data.ticket_order
        });

        resolve(data.ticket_order);
      } else {
        yield put({ type: CREATE_EVENT_TICKET_ORDER_FAIL });
        reject({ form_errors, general_errors });
      }

      yield put({ type: CREATE_EVENT_TICKET_ORDER_ASYNC_END });
    } catch (error) {
      const messages = ["انجام درخواست مقدور نبود. میتوانید مجددا تلاش"];
      reject({ general_errors: messages });

      yield put({ type: CREATE_EVENT_TICKET_ORDER_FAIL, error });
      yield put({ type: CREATE_EVENT_TICKET_ORDER_ASYNC_END });
      console.log(error);
    }
  }
}

export function* deleteEventTicket() {
  while (true) {
    const { ticketId, resolve, reject } = yield take(
      DELETE_EVENT_TICKET_REQUEST
    );
    yield put({ type: DELETE_EVENT_TICKET_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.deleteTicketFromEvent, ticketId);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: DELETE_EVENT_TICKET_SUCCESS
        });

        resolve && resolve(data);
      } else {
        yield put({ type: DELETE_EVENT_TICKET_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: DELETE_EVENT_TICKET_ASYNC_END });
    } catch (error) {
      const messages = ["انجام درخواست مقدور نبود. میتوانید مجددا تلاش"];
      reject({ general_errors: messages });

      yield put({ type: DELETE_EVENT_TICKET_FAIL, error });
      yield put({ type: DELETE_EVENT_TICKET_ASYNC_END });

      console.log(error);
    }
  }
}

export function* deleteEventExtension() {
  while (true) {
    const { extensionId, resolve, reject } = yield take(
      DELETE_EVENT_EXTENSION_REQUEST
    );
    yield put({ type: DELETE_EVENT_EXTENSION_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.deleteExtensionFromEvent, extensionId);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: DELETE_EVENT_EXTENSION_SUCCESS
        });

        resolve && resolve(data);
      } else {
        yield put({ type: DELETE_EVENT_EXTENSION_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: DELETE_EVENT_EXTENSION_ASYNC_END });
    } catch (error) {
      const messages = ["انجام درخواست مقدور نبود. میتوانید مجددا تلاش"];
      reject({ general_errors: messages });

      yield put({ type: DELETE_EVENT_EXTENSION_FAIL, error });
      yield put({ type: DELETE_EVENT_EXTENSION_ASYNC_END });

      console.log(error);
    }
  }
}

export function* fetchSingleEvent() {
  while (true) {
    const { eventId, resolve, reject } = yield take(FETCH_SINGLE_EVENT_REQUEST);
    yield put({ type: FETCH_SINGLE_EVENT_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.getSingleEvent, eventId);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_SINGLE_EVENT_SUCCESS
        });

        resolve && resolve(data);
      } else {
        yield put({ type: FETCH_SINGLE_EVENT_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: FETCH_SINGLE_EVENT_ASYNC_END });
    } catch (error) {
      const messages = ["اشکالی نامعلوم رخ داد..."];
      reject({ general_errors: messages });

      yield put({ type: FETCH_SINGLE_EVENT_FAIL, error });
      yield put({ type: FETCH_SINGLE_EVENT_ASYNC_END });

      console.log(error);
    }
  }
}

export function* editEvent() {
  while (true) {
    const { eventId, formData, resolve, reject } = yield take(
      EDIT_EVENT_REQUEST
    );
    yield put({ type: EDIT_EVENT_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors }
        }
      } = yield call(api.editEvent, eventId, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: EDIT_EVENT_SUCCESS
        });

        resolve && resolve(data);
      } else {
        yield put({ type: EDIT_EVENT_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: EDIT_EVENT_ASYNC_END });
    } catch (error) {
      const messages = ["اشکالی نامعلوم رخ داد..."];
      reject({ general_errors: messages });

      yield put({ type: EDIT_EVENT_FAIL, error });
      yield put({ type: EDIT_EVENT_ASYNC_END });

      console.log(error);
    }
  }
}

export function* fetchEventTemplates() {
  while (true) {
    yield take(FETCH_ALL_EVENT_TEMPLATES_REQUEST);
    yield put({ type: FETCH_ALL_EVENT_TEMPLATES_ASYNC_START });

    try {
      const [badgesRes, certificatesRes, resultsRes] = yield call(
        api.getAllEventTemplates
      );

      if (
        statusCodeIsBelow400(badgesRes.status) &&
        statusCodeIsBelow400(certificatesRes.status) &&
        statusCodeIsBelow400(resultsRes.status)
      ) {
        yield put({
          type: FETCH_ALL_EVENT_TEMPLATES_SUCCESS,
          badges: badgesRes.data.data.templates,
          certificates: certificatesRes.data.data.templates,
          results: resultsRes.data.data.templates
        });
      } else {
        yield put({ type: FETCH_ALL_EVENT_TEMPLATES_FAIL });
      }

      yield put({ type: FETCH_ALL_EVENT_TEMPLATES_ASYNC_END });
    } catch (error) {
      yield put({ type: FETCH_ALL_EVENT_TEMPLATES_FAIL, error });
      yield put({ type: FETCH_ALL_EVENT_TEMPLATES_ASYNC_END });

      console.log(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/eventsSaga.js